import Icon from "@ant-design/icons";

const FullyFurnishedSvg = () => (
  <svg
    version="1.0"
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="25"
    viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet"
  >
    <g
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      fill="#31493C"
      stroke="none"
    >
      <path
        d="M3120 4465 l0 -175 -160 -80 -160 -80 0 -145 0 -145 720 0 720 0 0
145 0 145 -160 80 -160 80 0 175 0 175 -400 0 -400 0 0 -175z m640 -130 l0
-145 160 -80 c100 -50 160 -86 160 -95 0 -13 -70 -15 -560 -15 -490 0 -560 2
-560 15 0 9 60 45 160 95 l160 80 0 145 0 145 240 0 240 0 0 -145z"
      />
      <path
        d="M960 4480 l0 -80 -120 0 -120 0 0 -80 0 -80 120 0 120 0 0 -370 c0
-329 -2 -370 -16 -370 -27 0 -119 -101 -132 -146 -28 -94 -8 -169 63 -239 102
-103 243 -101 338 5 64 71 81 145 55 234 -13 45 -105 146 -132 146 -14 0 -16
41 -16 370 l0 370 360 0 360 0 0 -164 0 -164 -34 -6 c-67 -13 -171 -74 -228
-134 -187 -196 -182 -491 11 -675 195 -186 491 -180 674 12 182 191 182 472
-1 663 -57 60 -161 121 -228 134 l-34 6 0 164 0 164 200 0 200 0 0 80 0 80
-200 0 -200 0 0 80 0 80 -80 0 -80 0 0 -80 0 -80 -360 0 -360 0 0 80 0 80 -80
0 -80 0 0 -80z m1091 -749 c69 -33 112 -74 150 -143 31 -57 34 -70 34 -148 0
-79 -3 -90 -36 -150 -154 -280 -571 -191 -597 127 -11 144 76 275 218 327 60
22 170 15 231 -13z m-956 -396 c50 -49 15 -135 -55 -135 -41 0 -80 39 -80 80
0 41 39 80 80 80 19 0 40 -9 55 -25z"
      />
      <path
        d="M3120 2760 l0 -120 -1320 0 -1320 0 0 -80 0 -80 40 0 40 0 0 -1000 0
-1000 2000 0 2000 0 0 1000 0 1000 40 0 40 0 0 80 0 80 -360 0 -360 0 0 120 0
120 -160 0 -160 0 0 -80 0 -80 80 0 80 0 0 -40 0 -40 -240 0 -240 0 0 40 0 40
80 0 80 0 0 80 0 80 -160 0 -160 0 0 -120z m1280 -1200 l0 -920 -1840 0 -1840
0 0 920 0 920 1840 0 1840 0 0 -920z"
      />
      <path
        d="M3515 2311 c-45 -20 -70 -60 -70 -112 0 -42 5 -53 33 -81 28 -28 39
-33 82 -33 43 0 54 5 82 33 28 28 33 39 33 82 0 42 -5 54 -31 81 -33 33 -92
46 -129 30z"
      />
      <path
        d="M3915 2311 c-45 -20 -70 -60 -70 -112 0 -42 5 -53 33 -81 28 -28 39
-33 82 -33 43 0 54 5 82 33 28 28 33 39 33 82 0 42 -5 54 -31 81 -33 33 -92
46 -129 30z"
      />
      <path
        d="M880 1520 l0 -720 840 0 840 0 0 720 0 720 -840 0 -840 0 0 -720z
m1520 320 l0 -240 -680 0 -680 0 0 240 0 240 680 0 680 0 0 -240z m0 -640 l0
-240 -680 0 -680 0 0 240 0 240 680 0 680 0 0 -240z"
      />
      <path d="M1520 1840 l0 -80 160 0 160 0 0 80 0 80 -160 0 -160 0 0 -80z" />
      <path d="M1520 1200 l0 -80 160 0 160 0 0 80 0 80 -160 0 -160 0 0 -80z" />
      <path
        d="M2800 1400 l0 -520 720 0 720 0 0 520 0 520 -720 0 -720 0 0 -520z
m1280 0 l0 -360 -560 0 -560 0 0 360 0 360 560 0 560 0 0 -360z"
      />
      <path d="M3360 1600 l0 -80 160 0 160 0 0 80 0 80 -160 0 -160 0 0 -80z" />
    </g>
  </svg>
);

const FullyFurnishedIcon = (props) => (
  <Icon component={FullyFurnishedSvg} {...props} />
);

export default FullyFurnishedIcon;
